


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ApiHelper from '~/helpers/api-helper';
import SelectService from '~/services/SelectService';

@Component
export default class PackageOrder extends Vue {
	@Prop({ default: null, required: false }) private model;
	private items: {}[] = [];
	private filter = null;
	private filterName = '';

	@Watch('model')
	modelChange(value) {
		this.filter = value;
	}

	async fetch() {
		if (this.model) {
			this.filter = this.model;
		}
		await this.getSelectorList();
	}

	async getSelectorList() {
		await SelectService.selectList(this.$axios, 'package_order')
			.then(res => {
				if (res) {
					this.prepareOptions(res);
				}
			})
			.catch(error => {
				ApiHelper.handleErrors(error, {}, this.$nuxt);
			});
	}

	prepareOptions(data) {
		this.items = [];
		for (const element of data) {
			this.items.push({
				text: element['name'],
				value: element['id'],
			});
		}
	}

	selectFilter(data) {
		this.items.forEach(value => {
			if (data == value['value']) {
				this.filterName = value['text'];
				return;
			}
		});
		this.$emit('input', data);
	}
}
